import React from 'react';
import Modal from '../Common/Modal/Modal';
import InputText from '../Common/InputText';
import Notification from '../Common/Notification';
import Button from '../Common/Button';

export default class Index extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            Modal2Text: "Default Value from State"
        }
    }

    showErrorNotification = () => {
        Notification("error", "Error Happened", "The error message to the user");
    }

    showWarningNotification = () => {
        Notification("warning", "Warning", "Be careful!");
    }

    showSuccessNotification = () => {
        Notification("success", "Good Job", "You are the greatest!");
    }

    onModal1Ok = () => {
        alert("Modal 1 OK");
    }

    onModal1Cancel = () => {
        alert("Modal 1 Cancel!");
    }

    Modal2TextChange = (event) => {
        this.setState({ Modal2Text: event.target.value });
    }
    onModal2Ok = () => {
        alert("Modal 2 OK : " + this.state.Modal2Text);
    }

    onModal2Cancel = () => {
        alert("Modal 2 Cancel!");
    }

    render() {

        let modal2contents = <div className="container"><InputText name="dummy" label="Something" type="text" placeholder="Something" value={this.state.Modal2Text} onChange={this.Modal2TextChange} /></div>;
        return (
            <div className="guide-page">
                <h3 className="guide-title">Notifications</h3>
                <p className="guide-lead">Here are the 3 different ways we notify the user of things.</p>

                <h4>Alerts</h4>
                <p>These are used within a form to tell the user an important message and are usually trigger by validation or after an event.</p>
                <div className="alert alert-success">Something was successful!</div>
                <div className="alert alert-warning">Be careful!</div>
                <div className="alert alert-dark">This is slick!</div>
                <div className="alert alert-danger">Danger ahead!</div>

                <h4>Toast Messages</h4>
                <p>We use the Notification component which is a wrapper for toastr to display messages to the user after save and update events. All of these messages go in the upper-right corner of the browser.</p>

                <div className="component">
                    <label>Parameters:</label>
                    <div className="param"><span className="param-name">type</span><span className="param-type">[string]</span><span className="param-desc">Possible values for type: warning, success, info or error</span></div>
                    <div className="param"><span className="param-name">title</span><span className="param-type">[string]</span><span className="param-desc">The text that appears at the top of the toast message</span></div>
                    <div className="param"><span className="param-name">msg</span><span className="param-type">[string]</span><span className="param-desc">The text that appears below the title</span></div>
                </div>
                <br />
                <p>Error - The only message type that is click to dismiss.</p>
                <Button type="button" text="Show Error Motification" bootstrapClass="danger me-2" onClick={this.showErrorNotification} />
                <Button type="button" text="Show Warning Motification" bootstrapClass="warning me-2" onClick={this.showWarningNotification} />
                <Button type="button" text="Show Success Motification" bootstrapClass="success" onClick={this.showSuccessNotification} />
                <br />
                <br />
                <h4>Modals</h4>
                <p>Modals are used when 1) You need to convey an import message that is larger than what an alert or toastr message can show or 2) To get feedback from the user from a certain event.</p>
                <p>The second example here is showing how to pass in a component to be rendered inside the modal for cases when you want to embed a form inside.</p>
                <Modal id="hw" title="Hello" body="world" onSecondaryClick={this.onModal1Cancel} onPrimaryClick={this.onModal1Ok} />
                <button className="btn btn-primary" data-toggle="modal" data-target="#hw">Launch Modal</button>
                <br /><br />
                <Modal id="compo_example" title="Hello" body={modal2contents} onSecondaryClick={this.onModal2Cancel} onPrimaryClick={this.onModal2Ok} />
                <button className="btn btn-primary" data-toggle="modal" data-target="#compo_example">Launch Modal With Element</button>
                <br />
                <br />
            </div>
        );
    }
}